import React from "react";

export default function ChatSide() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.08984 9.73633H14.6457"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M7.08984 13.042H12.2845"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M15.5891 2.97156C14.1999 2.16794 12.587 1.70801 10.8667 1.70801C5.65046 1.70801 1.42188 5.9366 1.42188 11.1528C1.42188 12.6637 1.77664 14.0917 2.4074 15.3581C2.57503 15.6947 2.63082 16.0793 2.53364 16.4425L1.9711 18.545C1.7269 19.4577 2.56187 20.2926 3.47457 20.0484L5.57702 19.4859C5.94021 19.3887 6.32488 19.4445 6.66142 19.6121C7.92782 20.2429 9.35581 20.5977 10.8667 20.5977C16.0829 20.5977 20.3115 16.369 20.3115 11.1528C20.3115 9.43255 19.8516 7.81963 19.048 6.43042"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
}
